import { useCallback, useContext, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { config } from '@config/pendo.config.json';
import BrowseMentorsModal from './browse-mentors-modal';
import MentoringProgramContext from 'athena/components/mentoring-program/context';
import { FirstSeenKey } from 'athena/components/constants';
import { useAppDispatch } from 'redux/store';
import { clearLastMentorsSearchAndFilters } from 'redux/actions/mentoring-program-participant-driven';
import { AngularContext } from 'react-app';

type FindAMentorButtonProps = {
  localStorageKey: string;
  label: string;
};

const FindAMentorButton = ({ localStorageKey, label }: FindAMentorButtonProps) => {
  const dispatch = useAppDispatch();
  const { injectServices } = useContext(AngularContext);
  const [$state] = injectServices(['$state']);
  const { showBrowseMentors = false } = $state.params;
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { showFindMentorModal, setShowFindMentorModal } = mentoringProgram;

  const handleOpenFindMentorModal = () => {
    localStorage.setItem(localStorageKey, 'true');
    setShowFindMentorModal(true);
  };

  const handleCloseFindMentorModal = () => {
    dispatch(clearLastMentorsSearchAndFilters());
    setShowFindMentorModal(false);
  };

  const resetShowBrowseMentorsParam = useCallback(() => {
    const params = { showBrowseMentors: undefined };
    $state.go($state.current, params, { notify: false });
  }, [$state]);

  useEffect(() => {
    if (showBrowseMentors) {
      setShowFindMentorModal(true);
      resetShowBrowseMentorsParam();
    }
  }, [showBrowseMentors, setShowFindMentorModal, resetShowBrowseMentorsParam]);

  const dataQATag = config.pendo.athena.mentorshipProgram.participantHome.steps.findAMentor;

  return (
    <>
      <Button
        size='lg'
        onClick={handleOpenFindMentorModal}
        data-qa={dataQATag}
      >
        {label}
      </Button>
      {showFindMentorModal && (
        <BrowseMentorsModal
          onClose={handleCloseFindMentorModal}
        />
      )}
    </>
  );
};

export default FindAMentorButton;
